import { render, staticRenderFns } from "./classify22.vue?vue&type=template&id=e0d9a9d8"
import script from "./classify22.vue?vue&type=script&lang=js"
export * from "./classify22.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports